import React from 'react';
import { BringzzText, BringzzIcon } from "@bringzz/components";

const ManufacturerTab = ({ manufacturers, isAllCategory, onItemClick, onManufacturerProductsClick }) => {
    const handleManufacturerProductsClick = (manufacturer) => {
        if (onManufacturerProductsClick) {
            onManufacturerProductsClick(manufacturer.id, manufacturer.legal_name);
        }
    };

    const renderManufacturerItem = (manufacturer, index, section) => {
        if (isAllCategory) {
            return (
                <div key={`${section}-${manufacturer.id}-${index}`} className='flex items-center border-b py-2 cursor-pointer' onClick={() => handleManufacturerProductsClick(manufacturer)}>
                    <div className='flex space-x-1 items-center'>
                        <BringzzText tag='h4'>{manufacturer.legal_name}</BringzzText>
                    </div>
                    <BringzzIcon
                        size="16"
                        icon="IconChevronRight"
                        folder="LineIcons"
                        className="text-gray-400"
                    />
                </div>
            );
        }
        
        return (
            <div key={`${section}-${manufacturer.id}-${index}`} className='flex justify-between items-center border-b py-2 cursor-pointer' onClick={() => handleManufacturerProductsClick(manufacturer)}>
                <div className='flex space-x-1 items-center'>
                    <BringzzText tag='h4'>{manufacturer.legal_name}</BringzzText>
                </div>
                <BringzzIcon
                    size="16"
                    icon="IconChevronRight"
                    folder="LineIcons"
                    className="text-gray-400"
                />
            </div>
        );
    };

    return { renderManufacturerItem };
};

export default ManufacturerTab;